import { FilterFn, Row } from '@tanstack/react-table';

import { CatalogItem } from '@/pages/Catalog/types';
import { SelectedSymbol } from '@/types/symbols';

export const arrEqualsAll: FilterFn<CatalogItem> = (
  row: Row<CatalogItem>,
  columnId: string,
  filterValue: string[]
) => {
  if (typeof filterValue?.[0] !== 'string') return true;
  return filterValue.every(selectedFilterValue => {
    const value: string = row.getValue(columnId);
    return value?.toLocaleLowerCase() === selectedFilterValue.toLocaleLowerCase();
  });
};
export const filterByStatus: FilterFn<CatalogItem> = (
  row: Row<CatalogItem>,
  columnId: string,
  filterValue: string[]
) => {
  const selectedFilterValue = filterValue[0];
  if (!selectedFilterValue) {
    const value = row.getValue(columnId);
    return value !== 'Archive';
  }
  return true;
};

export const filterBySelectedCode: FilterFn<CatalogItem> = (
  row: Row<CatalogItem>,
  columnId: string,
  filterValue: SelectedSymbol[]
) => {
  if (!filterValue.length) return true;
  return filterValue.some(selectedSymbol => {
    const symbol = {
      Code: row.getValue('Code'),
      Period: row.getValue('Period'),
      PeriodType: row.getValue('PeriodType'),
      TimeRef: row.getValue('TimeRef')
    };

    return (
      symbol.Code === selectedSymbol.Code &&
      symbol.Period === selectedSymbol.Period &&
      symbol.PeriodType === selectedSymbol.PeriodType &&
      symbol.TimeRef === selectedSymbol.TimeRef
    );
  });
};
